/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page

      if (variant.available === true) {
        if (null !== document.querySelector('.btn.klaviyo-bis-trigger')) {
          document.querySelector('.btn.klaviyo-bis-trigger').style.display = 'none';
        }
      } else {
        if (null !== document.querySelector('.btn.klaviyo-bis-trigger')) {
          document.querySelector('.btn.klaviyo-bis-trigger').style.display = 'inline-block';
        }
      }

      // cb product siblings
      if ($('.cb-product__block__siblings').length > 0) {
        $('.cb-siblings-metadata.cross-sib').each(function (idx, json_el) {
          let sib_combinations_json = JSON.parse($(json_el).text());
          for (let idx = 0; idx < sib_combinations_json.length; idx++) {
            if (sib_combinations_json[idx].option1 === variant.option1 && sib_combinations_json[idx].option2 === variant.option2) {
              let currSibLinkEl = $('.cb-product__block__siblings a[data-sib_prd_id="' + sib_combinations_json[idx].product_id + '"]');
              if (currSibLinkEl.length > 0) {
                let currSibLinkHref = $(currSibLinkEl).attr('href');
                currSibLinkHref = currSibLinkHref.split('?')[0];
                $(currSibLinkEl).attr('href', currSibLinkHref + '?variant=' + sib_combinations_json[idx].id);
                break;
              }
            }
          }
        });
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  $(function () {
    $('form .product-personalizer').attr('data-morph-skip', '');
  });
})();
